import * as angular from "angular";
import {IComponentController, ITimeoutService} from "angular";

class TextBoxController implements IComponentController {
    input: any;
    private copied: boolean;

    constructor(private $timeout: ITimeoutService) {
    }

    $onInit(): void {
    }

    copy = () => {
        console.debug('copy', this.input);
        this.input.select();
        document.execCommand('copy');
        this.copied = true;
        this.$timeout(() => this.copied = false, 2000);

    }
}

export default angular.module('component.textBox', [])
    .component('textbox', {
        template: require('./TextBox.html'),
        controller: TextBoxController,
        controllerAs: '$ctrl',
        bindings: {
            model: '=',
            value: '=',
            required: '=',
            readonly: '=',
            disabled: '=',
            placeholder: '@',
            class: '@',
            showCopy: '=',
        }
    }).name;
